var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.736 53.7741C64.736 57.5541 65.8115 59.0616 68.624 59.0616C74.8925 59.0616 78.884 51.0741 78.884 37.7901C78.884 17.4861 64.088 7.76611 45.6155 7.76611C26.612 7.76611 9.32752 20.5101 9.32752 44.5941C9.32752 67.5981 24.4475 80.1261 47.6675 80.1261C55.5515 80.1261 60.8435 79.2621 68.939 76.5621L70.676 83.7936C62.684 86.3901 54.143 87.1416 47.5595 87.1416C17.1035 87.1416 0.791016 70.4016 0.791016 44.5896C0.791016 18.5616 19.6955 0.849609 45.7235 0.849609C72.8315 0.849609 87.191 17.0496 87.191 36.9216C87.191 53.7696 81.9035 66.6216 65.2715 66.6216C57.707 66.6216 52.7435 63.5976 52.0955 56.8971C50.1515 64.3491 44.9675 66.6216 37.943 66.6216C28.547 66.6216 20.663 59.3811 20.663 44.8056C20.663 30.1176 27.5795 21.0456 39.9995 21.0456C46.5875 21.0456 50.6915 23.6376 52.5185 27.7416L55.655 22.0176H64.727V53.7741H64.736ZM51.4565 39.5181C51.4565 33.5826 47.024 31.0941 43.352 31.0941C39.356 31.0941 34.9325 34.3296 34.9325 43.8381C34.9325 51.3981 38.2805 55.6101 43.352 55.6101C46.916 55.6101 51.4565 53.3421 51.4565 47.0781V39.5181Z",
    fill: "url(#paint0_linear_340_12937)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_12937",
    x1: 0.999999,
    y1: 1,
    x2: 87,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#075985"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b6dee67b4ff051f0e35759e1bc757fdf.svg";
export { ForwardRef as ReactComponent };